import React from 'react'

export default function CardFooter({ total }) {
  return (
    <>
      <strong style={{ fontSize: '13px' }}><em>{total}</em></strong>
    </>
  )
}
